module.exports = __webpack_public_path__ + "static/media/ic_choose_by_url.48474565.svg";